export const STATE_STYLE = {
  creado:       { label: "Creado",              color: "bg-zinc-800 text-zinc-300 border-zinc-700" },
  pendiente:    { label: "Pendiente de retiro", color: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
  retirado:     { label: "Retirado",            color: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30" },
  en_bodega:    { label: "En bodega",           color: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  en_reparto:   { label: "En reparto",          color: "bg-yellow-300/15 text-yellow-300 border-yellow-300/40" },
  entregado:    { label: "Entregado",           color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  no_entregado: { label: "No entregado",        color: "bg-red-500/15 text-red-300 border-red-500/30" },
};

export const STATE_ORDER = ["creado", "pendiente", "retirado", "en_bodega", "en_reparto", "entregado"];

export function StateBadge({ state, className = "" }) {
  const s = STATE_STYLE[state] || STATE_STYLE.creado;
  return (
    <span
      data-testid={`state-badge-${state}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 border text-xs font-mono-tech uppercase tracking-wider ${s.color} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
}
